/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCastVote = /* GraphQL */ `
  subscription OnCastVote {
    onCastVote {
      id
      name
      description
      votes
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCandidate = /* GraphQL */ `
  subscription OnCreateCandidate {
    onCreateCandidate {
      id
      name
      description
      votes
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCandidate = /* GraphQL */ `
  subscription OnUpdateCandidate {
    onUpdateCandidate {
      id
      name
      description
      votes
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCandidate = /* GraphQL */ `
  subscription OnDeleteCandidate {
    onDeleteCandidate {
      id
      name
      description
      votes
      createdAt
      updatedAt
    }
  }
`;
